export default {
  name: 'switch-input',
  props: ['value'],
  model: {
    prop: 'value',
    event: 'change'
  }
}
